<template>
    <v-link :href="link" target="_blank" :class="theme.card" v-margin="1">
        <img :src="poster" :claass="theme.poster" />
        <div v-padding="2">
            <div v-if="date">
                <v-text type="caption">
                    {{ moment(date).format('DD.MM.YYYY') }}
                </v-text>
            </div>

            <v-text bold :claass="theme.title">
                {{ title }}
            </v-text>
        </div>
    </v-link>
</template>

<script>
    import moment from 'moment';
    import theme from './theme.scss';

    export default {
        name: 'training-card',
        props: {
            poster: String,
            date: String,
            title: String,
            link: String,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        methods: {
            moment,
        }
    }
</script>


// WEBPACK FOOTER //
// TrainingCard.vue?42e6fd00